import { useEffect } from 'react'

const useOutsideClick = (
  ref: React.RefObject<HTMLElement>,
  callback: (clickTarget: Node) => void
) => {
  useEffect(() => {
    // Function to handle click events
    function handleClickOutside(event: MouseEvent): void {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback(event.target as Node)
      }
    }

    // Add event listener on document
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      // Clean up the event listener on unmount
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref, callback])
}

export default useOutsideClick
